var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LibMask',{on:{"before-close":_vm.close}},[_c('div',{staticClass:"Dialog"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),_c('i',{staticClass:"iconfont icon-guanbi close click",on:{"click":_vm.close}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }